import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import BookDetailPage from "../components/BookDetailPage";

export default function BookDetail() {
  

  return (
    <>
    <Navbar />
    <BookDetailPage />
    <Footer />
    </>
  );
}
